import React from 'react'
import { Col, Row } from 'react-bootstrap'

const AttributesDetails = ({ categoryData }) => {
	const specificationCheck =
		categoryData?.specifications?.diameter ||
		categoryData?.specifications?.height ||
		categoryData?.specifications?.length ||
		categoryData?.specifications?.thickness ||
		categoryData?.specifications?.width

	return (
		<div className='attribute-details-container'>
			{specificationCheck && categoryData?.description2 && (
				<Row className='specification-wapper'>
					{specificationCheck && (
						<>
							<Row className='border-top pt-2 '>
								<p className='attributes-sub-heading'>Specification</p>
							</Row>
							<Col xs={12} md={6} lg={6}>
								<div className='list-group'>
									{categoryData?.specifications?.diameter && (
										<div className='list-group-item list-group-item-action'>
											<Row className='align-items-center'>
												<Col md={6}>
													<p className='attributes-description'>Diameter</p>
												</Col>
												<Col md={6}>
													<p className='attributes-description-value'>{categoryData?.specifications?.diameter}</p>
												</Col>
											</Row>
										</div>
									)}
									{categoryData?.specifications?.height && (
										<div className='list-group-item list-group-item-action list-group-item-light'>
											<Row className='align-items-center'>
												<Col md={6}>
													<p className='attributes-description'>Height</p>
												</Col>
												<Col md={6}>
													<p className='attributes-description-value'>{categoryData?.specifications?.height}</p>
												</Col>
											</Row>
										</div>
									)}
									{categoryData?.specifications?.length && (
										<div className='list-group-item list-group-item-action'>
											<Row className='align-items-center'>
												<Col md={6}>
													<p className='attributes-description'>Length</p>
												</Col>
												<Col md={6}>
													<p className='attributes-description-value'>{categoryData?.specifications?.length}</p>
												</Col>
											</Row>
										</div>
									)}
									{categoryData?.specifications?.thickness && (
										<div className='list-group-item list-group-item-action list-group-item-light'>
											<Row className='align-items-center'>
												<Col md={6}>
													<p className='attributes-description'>Thickness</p>
												</Col>
												<Col md={6}>
													<p className='attributes-description-value'>{categoryData?.specifications?.thickness}</p>
												</Col>
											</Row>
										</div>
									)}
									{categoryData?.specifications?.width && (
										<div className='list-group-item list-group-item-action'>
											<Row className='align-items-center'>
												<Col md={6}>
													<p className='attributes-description'>Width</p>
												</Col>
												<Col md={6}>
													<p className='attributes-description-value'>{categoryData?.specifications?.width}</p>
												</Col>
											</Row>
										</div>
									)}
								</div>
							</Col>
						</>
					)}
					{categoryData?.description2 && (
						<Col xs={12} md={6} lg={6}>
							<div
								className='product-description sun-editor-editable tag-text-direction'
								dangerouslySetInnerHTML={{ __html: categoryData?.description2 }}
							/>
						</Col>
					)}
				</Row>
			)}
			<div>
				{categoryData?.advantage && (
					<Row>
						<h2 className='attributes-title text-center'>Advantages</h2>
						<div
							className='attributes-description sun-editor-editable tag-text-direction'
							dangerouslySetInnerHTML={{ __html: categoryData?.advantage }}
						/>
					</Row>
				)}
				{categoryData?.application && (
					<Row>
						<h2 className='attributes-title text-center'>Applications</h2>
						<div
							className='attributes-description sun-editor-editable tag-text-direction'
							dangerouslySetInnerHTML={{ __html: categoryData?.application }}
						/>
					</Row>
				)}
			</div>
		</div>
	)
}

export default AttributesDetails
